export enum LootboxPurchaseStep {
  inProgress,
  blockchainConfirmation,
  noFunds,
  success,
  failed,
}
